import { render, staticRenderFns } from "./Resep.vue?vue&type=template&id=bff12308&"
import script from "./Resep.vue?vue&type=script&lang=js&"
export * from "./Resep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports